import { PriceItem, Skeleton } from 'components'
import flowRight from 'lodash/flowRight'
import { makeSelectPctById } from 'logic/pcts'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import PropTypes from 'prop-types'

class OfferItem extends Component {

  static propTypes = {
    date: PropTypes.object.isRequired,
  }

  render() {
    const { pct, offer, date } = this.props
    if (!pct) return <div className="tt-offer-item"><Skeleton /></div>

    return (
      <div className="tt-offer-item">
        <PriceItem {...{ pct, offer, date }} />
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  pct: makeSelectPctById(props => props.offer.price_category_id),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
  }, dispatch)
});

const enhance = flowRight(
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(OfferItem)
